module.exports = __webpack_public_path__ + "img/category-Romance.05bd2764.svg";